import { Token } from './token'

/**
 * Known SAMB implementation addresses, used in our implementation of Ether#wrapped
 */
export const SAMB: { [chainId: number]: Token } = {
  16718: new Token(16718, '0x2b2d892C3fe2b4113dd7aC0D2c1882AF202FB28F', 18, 'SAMB', 'Synthetic Amber'),
  22040: new Token(22040, '0x2Cf845b49e1c4E5D657fbBF36E97B7B5B7B7b74b', 18, 'SAMB', 'Synthetic Amber'),
  30746: new Token(30746, '0x2F52348a707ede8Dbcf2BF79cbd65406E92522BD', 18, 'SAMB', 'Synthetic Amber'),
}
